export enum FeatureAttributeEnum {
  ORGANISATION_ID = "organisationId",
  USER_ID = "userId",
}
